export default "__VITE_ASSET__BwzAlr87__";